import React, { useEffect, useState } from "react";
import { getProfileExternalInfo } from "utils/enduserUtils";
import { ProfileExternalInfo, ProfileExternalInfoSource } from "models/profile/ProfileExternalInfo";
import { Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Grid } from "@mui/material";
import { EnumAutocomplete, TextEnumAutocomplete } from "components/alove/EnumAutocomplete";
import { DataGridPro } from "@mui/x-data-grid-pro";

export const ProfileExternalInfoView = ({ profileId }: { profileId: string }) => {
  const [externalInfo, setExternalInfo] = useState<ProfileExternalInfo[]>([]);
  const [sourceFilter, setSourceFilter] = useState<ProfileExternalInfoSource>(ProfileExternalInfoSource.AIAgent);

  useEffect(() => {
    if (!profileId) return;
    getProfileExternalInfo(profileId).then((res) => {
      setExternalInfo(res || []);
    });
  }, [profileId]);


  const filteredInfo = externalInfo.filter((info) => info.source === sourceFilter);

  return (
    <Grid container spacing={2}>
      <Grid size={6}>
          <TextEnumAutocomplete
            enumName={ProfileExternalInfoSource}
          value={sourceFilter}
          onChange={(val) => setSourceFilter(val)}
        />
      </Grid> 
      <Grid size={12}>
      {filteredInfo.length === 0 ? (
        <Typography variant="body2">No external info available.</Typography>
      ) : (
        <DataGridPro
          rows={filteredInfo}
          getRowId={(row) => row.attributeName || ''}
          density="compact"
          columns={[
            {
              field: 'attributeName',
              headerName: 'Attribute Name',
              flex: 1,
            },
            {
                field: 'attributeValue',
                headerName: 'Attribute Value',
                flex: 1,
            },
            {
                field: 'source',
                headerName: 'Source',
                flex: 1,
            },
          ]}
        />
      )}
    </Grid>
    </Grid>
  );
}; 